import React, { useEffect, useRef, useState } from "react";
import { Loader, MessageCircleQuestion } from "lucide-react";
import Spacing from "../Spacing";
import { resendScheduler } from "../../services/users";
import { Drawer } from 'vaul';

export default function ResendSchedulerConfirmModal(
  { 
    openModal = false, 
    setOpenModal = () => {},
    confirmAction = () => {}, 
    resendLoader = false,
    setResendLoader = () => {},
    account_id,
    location_id,
    resendSchedulerId = null,
    setResendSchedulerId = () => {},
    previousScrollPosition = 0
  }
) {
  const [schedulerPatientData, setSchedulerPatientData] = useState(null);
  const [schedulerPatientsLoader, loadSchedulerPatientsLoader] = useState(true);
  const dropdownRef = useRef(null);
  
  useEffect(() => {
    loadSchedulerPatients(account_id, location_id, resendSchedulerId);
  }, [account_id, location_id, resendSchedulerId]);

  const loadSchedulerPatients = async (accountId, locationId, resendSchedulerId) => {
    try {
      const resendParams = {
        account_id: accountId,
        location_id: locationId,
        scheduler_id: resendSchedulerId,
        read: true
      }
      const result = await resendScheduler(resendParams);
      
      if(result){
        if(!result?.detail && result?.data?.status === 'success'){
          setSchedulerPatientData(result?.data?.total_patient);
        } else {
          console.log("🚀 ~ loadSchedulerPatients ~ error:", result?.data?.message);
        }
      }
    } catch (error) {
      // console.log("🚀 ~ loadSchedulerPatients ~ error:", error);
    } finally {
      loadSchedulerPatientsLoader(false);
    }
  };

  const handleDrawerClose = () => {
    setOpenModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={openModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small">
            <Drawer.Title className="sr-only">Confirmation Modal</Drawer.Title>
            <Drawer.Description className="sr-only">Confirmation to send message</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal" style={{ minHeight: '320px' }}>
                <div className="docpro_deleteboxbox" style={{ height: '100%' }}>
                  {!schedulerPatientsLoader ? 
                    <>
                      <div className="modal_height_100">
                        <div>
                          <div className="docpro_iconbox_icon docpro_badge_orange">
                            <MessageCircleQuestion width={50} height={50} />
                          </div>
                          <Spacing lg="20" sm="20" />
                          <div className="docpro_iconbox_right">
                            <h3 className="docpro_fs_20">Are you Sure?</h3>
                            <p className="docpro_mb_0 docpro_fs_16">
                              You want to proceed with sending the message to <br /><b className="docpro_green_color">{schedulerPatientData || 0}</b> patients using this scheduler setup?
                            </p>
                            {resendLoader && (
                              <>
                                <Spacing lg="15" sm="15" />
                                <p className="docpro_red_color">Message is being prepared. Please keep the browser open</p>
                              </>
                            )}
                            <Spacing lg="32" sm="32" />
                          </div>
                        </div>
                        <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                          <button
                            className="docpro_bordered_btn docpro_fw_600 size_lg"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handleDrawerClose();
                              setResendLoader(false);
                              setResendSchedulerId(null);
                            }}
                            style={{ minWidth: '100px' }}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg docpro_btn_green`}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              confirmAction();
                            }}
                            style={{ minWidth: '100px' }}
                            disabled={resendLoader ? true : false}
                          >
                            <span>Yes</span>
                            {resendLoader && (
                              <span className="docpro_loading">
                                <Loader width={20} height={20} />
                              </span>
                            )}
                          </button>
                        </div>
                      </div>
                    </>
                  :
                    <div className="flex items-center loading" style={{ width: '90%', height: '90%', minHeight: '263px', position: 'absolute', top: 0, background: '#ffffff9c', borderRadius: '10px', justifyContent: 'center' }}>
                      <span className="docpro_loading" style={{ position: 'inherit' }}>
                        <Loader width={46} height={46} style={{ color: 'var(--accent)' }} />
                      </span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
